import { render } from "./Spda.vue?vue&type=template&id=035c921d"
import script from "./Spda.vue?vue&type=script&lang=js"
export * from "./Spda.vue?vue&type=script&lang=js"
script.render = render

export default script